export function resolveTierQuantityForItem(
    item,
    parentItem = null,
    {
        getTotalItemQuantity,
        isAssemblyGroup,
        getAssemblyGroupedItems
    } = {}
) {
    if (!item || typeof getTotalItemQuantity !== "function") return 0;

    const lineQuantity = getTotalItemQuantity(item);
    if (
        typeof isAssemblyGroup !== "function" ||
        typeof getAssemblyGroupedItems !== "function"
    ) {
        return lineQuantity;
    }

    const isChildOfParent =
        parentItem &&
        Array.isArray(parentItem.subItems) &&
        parentItem.subItems.some(
            (subItem) => String(subItem.id) === String(item.id)
        );

    const sameAssemblyIdentity =
        parentItem &&
        ((parentItem.group_assembly_id &&
            item.group_assembly_id &&
            String(parentItem.group_assembly_id) ===
                String(item.group_assembly_id)) ||
            (parentItem.saved_design_id &&
                item.saved_design_id &&
                String(parentItem.saved_design_id) ===
                    String(item.saved_design_id)));

    const assemblyRoot =
        parentItem &&
        (isAssemblyGroup(parentItem) || (isChildOfParent && sameAssemblyIdentity))
            ? parentItem
            : isAssemblyGroup(item)
            ? item
            : null;

    if (!assemblyRoot) return lineQuantity;

    const assemblyQuantity = getAssemblyGroupedItems(assemblyRoot).reduce(
        (sum, groupedItem) => sum + getTotalItemQuantity(groupedItem),
        0
    );

    return assemblyQuantity > 0 ? assemblyQuantity : lineQuantity;
}
